module.exports = __webpack_public_path__ + "logo-pre.jpg?472c3d013fe3a58d087eed54f8c27793";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-pre.jpg
// module id = 36
// module chunks = 0